// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.searchModal_boxModal__xK6WH {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: scroll;
  height: 90%;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
}

.searchModal_boxModal__xK6WH .searchModal_exit__yg4TK {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
}

.searchModal_boxModal__xK6WH .searchModal_exit__yg4TK .searchModal_exitIcon__lityE {
  font-size: 1.5rem;
  transition: 0.3s;
}

.searchModal_boxModal__xK6WH .searchModal_exit__yg4TK .searchModal_exitIcon__lityE:hover {
  transition: 0.2s;
  scale: 1.1;
  cursor: pointer;
  filter: brightness(1.6);
}

.searchModal_boxModal__xK6WH .searchModal_titleModal__EQw0F {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.searchModal_boxModal__xK6WH .searchModal_titleModal__EQw0F p {
  font-size: 1.3rem;
  margin: 0;
}

.searchModal_boxModal__xK6WH .searchModal_titleModal__EQw0F span {
  font-size: 0.9rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.searchModal_boxModal__xK6WH .searchModal_formFilters__ux5KV {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 85%;
  margin-top: 10px;
}

.searchModal_boxModal__xK6WH .searchModal_formFilters__ux5KV .searchModal_filter__jhcTU,
.searchModal_filterByType__O2skk {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  margin-top: 20px;
}

.searchModal_boxModal__xK6WH .searchModal_formFilters__ux5KV .searchModal_filterByType__O2skk p {
  color: #5a5a5a;
  font-size: 1rem;
  margin-right: 25px;
}

.searchModal_boxModal__xK6WH .searchModal_formFilters__ux5KV .searchModal_filter__jhcTU .searchModal_filterButton__Mg9Oc {
  margin-bottom: 20px;
}

@media screen and (max-width: 900px) {
  .searchModal_boxModal__xK6WH {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/SearchModal/searchModal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  overflow-y: scroll;\n  height: 90%;\n  max-height: 90%;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  font-size: 1.5rem;\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.1;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 0.9rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .formFilters {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: 85%;\n  margin-top: 10px;\n}\n\n.boxModal .formFilters .filter,\n.filterByType {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 80px;\n  margin-top: 20px;\n}\n\n.boxModal .formFilters .filterByType p {\n  color: #5a5a5a;\n  font-size: 1rem;\n  margin-right: 25px;\n}\n\n.boxModal .formFilters .filter .filterButton {\n  margin-bottom: 20px;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `searchModal_boxModal__xK6WH`,
	"exit": `searchModal_exit__yg4TK`,
	"exitIcon": `searchModal_exitIcon__lityE`,
	"titleModal": `searchModal_titleModal__EQw0F`,
	"formFilters": `searchModal_formFilters__ux5KV`,
	"filter": `searchModal_filter__jhcTU`,
	"filterByType": `searchModal_filterByType__O2skk`,
	"filterButton": `searchModal_filterButton__Mg9Oc`
};
export default ___CSS_LOADER_EXPORT___;
